import React, { FC } from "react";
import { Location } from "history";
import { Nav } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import { selectOrganization } from "go-security/services/organizations/selectors";

interface Props {
	stocktakingId: number;
}

const SubmenuStocktakingNavigation: FC<Props> = ({ stocktakingId }) => {
	const organization = useSelector(selectOrganization);
	const { t } = useTranslation();

	return (
		<div className="content-navigation">
			{
				<Nav>
					<Nav.Item>
						<Nav.Link
							as={NavLink}
							to={`/${organization.id}/stocktakings/${stocktakingId}`}
							isActive={(_, location: Location) => {
								return (
									!location.pathname.includes("/summary") &&
									// !location.pathname.includes("/transactions") &&
									!location.pathname.includes("/drafts")
								);
							}}
						>
							{t("common.word.edition")}
						</Nav.Link>
					</Nav.Item>
					<Nav.Item>
						<Nav.Link as={NavLink} to={`/${organization.id}/stocktakings/${stocktakingId}/drafts`}>
							{t("modules.stocktaking.field.draft.title")}
						</Nav.Link>
					</Nav.Item>
					<Nav.Item>
						<Nav.Link as={NavLink} to={`/${organization.id}/stocktakings/${stocktakingId}/summary`}>
							{t("lib:common.word.summary")}
						</Nav.Link>
					</Nav.Item>
					{/* <Nav.Item>
						<Nav.Link as={NavLink} to={`/${organization.id}/stocktakings/${stocktakingId}/transactions`}>
							{t("common.word.transactions")}
						</Nav.Link>
					</Nav.Item> */}
				</Nav>
			}
		</div>
	);
};

export default SubmenuStocktakingNavigation;
